import React from "react"

import { Upload } from "lucide-react"

import { ACCEPT_STRING } from "./types"

interface AudioDropZoneProps {
  isDragging: boolean
  onDragOver: (e: React.DragEvent) => void
  onDragLeave: (e: React.DragEvent) => void
  onDrop: (e: React.DragEvent) => void
  onFilesSelected: (files: FileList) => void
}

const AudioDropZone: React.FC<AudioDropZoneProps> = ({
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onFilesSelected,
}) => (
  <div
    onDragOver={onDragOver}
    onDragLeave={onDragLeave}
    onDrop={onDrop}
    className={`w-full border border-dashed rounded-lg p-6 text-center transition-colors ${
      isDragging
        ? "border-coval-border-active bg-surface-1"
        : "border-coval-border-active bg-surface-0 hover:border-coval-border-active hover:bg-surface-1"
    }`}
  >
    <input
      type="file"
      id="audio-file-input"
      accept={ACCEPT_STRING}
      multiple
      className="hidden"
      onChange={(e) => {
        if (e.target.files && e.target.files.length > 0) {
          onFilesSelected(e.target.files)
        }
        e.target.value = ""
      }}
    />
    <label
      htmlFor="audio-file-input"
      className="cursor-pointer flex flex-col items-center gap-2"
    >
      <Upload
        className={`w-8 h-8 ${isDragging ? "text-coval-text" : "text-coval-text-muted"}`}
      />
      <div>
        <p className="text-sm font-medium text-coval-text">
          {isDragging ? "Drop files here" : "Click to upload or drag and drop"}
        </p>
        <p className="text-xs text-coval-text-muted mt-1">
          WAV, MP3, M4A (Max 50 MB per file)
        </p>
      </div>
    </label>
  </div>
)

export default AudioDropZone
